// Shopify stores custom line properties in the language used when adding an item.
// Translate those values before native checkout, including carts from an older visit.
(() => {
  const keys = ['Preorder dispatch', 'Planned dispatch', 'Geplanter Versand'];
  const values = {
    'Q1 2027 — exact date by email': 'zero',
    'Q1 2027 – genaues Datum per E-Mail': 'zero',
    'November 2026 — subject to production confirmation': 'calendar',
    'November 2026 – vorbehaltlich Produktionsbestätigung': 'calendar',
  };
  const busy = new WeakSet();
  const ready = new WeakSet();
  function translatedProperties(item) {
    const properties = Array.isArray(item.properties) ? Object.fromEntries(item.properties) : { ...item.properties };
    let changed = false;
    for (const key of keys) {
      if (!Object.hasOwn(values, properties[key])) continue;
      const value = values[properties[key]];
      if (!value || (key === window.bosPreorderStrings.label && properties[key] === window.bosPreorderStrings[value])) continue;
      delete properties[key];
      properties[window.bosPreorderStrings.label] = window.bosPreorderStrings[value];
      changed = true;
    }
    return changed ? properties : null;
  }
  async function cartRequest(url, body) {
    const response = await fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) } : {});
    if (!response.ok) throw new Error('Could not update cart language');
    const cart = await response.json();
    if (!Array.isArray(cart.items)) throw new Error('Invalid cart response');
    return cart;
  }
  if (!window.bosPreorderStrings.properties.some(properties => translatedProperties({ properties }))) return;
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    const button = event.submitter;
    if (button?.name !== 'checkout' || new URL(form.action).pathname !== window.routes.cart_url) return;
    if (ready.delete(form)) return;
    event.preventDefault();
    if (busy.has(form)) return;
    busy.add(form);
    const quantityInputs = [...form.elements].filter(input => input.name === 'updates[]' && !input.disabled);
    const quantities = quantityInputs.map(input => Number(input.value));
    button.disabled = true;
    try {
      let cart = await cartRequest(window.routes.cart_url + '.js');
      if (cart.items.some(translatedProperties)) {
        // Save pending quantity edits first; translating properties can merge lines.
        if (quantityInputs.length) {
          if (quantities.length !== cart.items.length || quantities.some(q => !Number.isSafeInteger(q) || q < 0)) throw new Error('Cart changed');
          cart = await cartRequest(window.routes.cart_update_url + '.js', { updates: Object.fromEntries(cart.items.map((item, index) => [item.key, quantities[index]])) });
        }
        let item;
        let remaining = cart.items.length;
        while ((item = cart.items.find(translatedProperties))) {
          if (remaining-- === 0) throw new Error('Cart language did not update');
          cart = await cartRequest(window.routes.cart_change_url + '.js', { id: item.key, quantity: item.quantity, properties: translatedProperties(item) });
        }
        // Native POST must use the current line order and quantities after merging.
        quantityInputs.forEach(input => { input.disabled = true; });
        if (quantityInputs.length) cart.items.forEach(item => {
          const input = document.createElement('input');
          input.type = 'hidden'; input.name = 'updates[]'; input.value = item.quantity;
          form.append(input);
        });
      }
      button.disabled = false;
      ready.add(form);
      form.requestSubmit(button);
      ready.delete(form);
    } catch (error) {
      await form.closest('cart-items')?.refreshSections().catch(() => {});
      let errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors') || form.querySelector('[data-preorder-error]');
      if (!errors) {
        errors = document.createElement('p');
        errors.dataset.preorderError = '';
        errors.setAttribute('role', 'alert');
        form.append(errors);
      }
      errors.textContent = window.cartStrings.error;
      button.disabled = false;
    } finally {
      busy.delete(form);
    }
  });
})();
